//-------------------------------------------------------------------------------------------------- Imports
import { ReactNode } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { FEATURE_RULES, FeatureKey } from "../routes/featureRules";

//-------------------------------------------------------------------------------------------------- Interfaces
interface FeatureGuardProps {
  feature: FeatureKey;
  redirectTo?: string;
  children: ReactNode;
}

//-------------------------------------------------------------------------------------------------- Component
const FeatureGuard = ({
  feature,
  redirectTo,
  children,
}: FeatureGuardProps) => {
  const rule = FEATURE_RULES[feature];
  const data = useSelector(rule.select);

  if (!rule.isReady(data)) {
    return null;
  }

  if (!rule.isAllowed(data)) {
    return <Navigate to={redirectTo ?? rule.redirectTo ?? "/my-data"} replace />;
  }

  return <>{children}</>;
};

//-------------------------------------------------------------------------------------------------- Exports
export default FeatureGuard;